<template>
  <div class="flex flex-col items-center text-center">
    <div class="mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-red-50 text-red-500">
      <TriangleAlert :size="28" />
    </div>
    <h2 class="text-xl font-bold text-gray-900">
      {{ $t('COMMON.ACCOUNT_DELETED_TITLE') }}
    </h2>
    <p class="mt-2 text-sm text-gray-600">
      {{ $t('COMMON.ACCOUNT_DELETED_MESSAGE') }}
    </p>
    <p class="mt-3 rounded-lg bg-amber-50 px-4 py-3 text-sm text-amber-800">
      {{ $t('COMMON.ACCOUNT_DELETED_CREDIT_RECOVERY') }}
    </p>
  </div>
</template>

<script setup lang="ts">
import {
  TriangleAlert,
} from "@lucide/vue";
</script>
